import { handleResponse } from './base.service';
import { authHeader } from '@/helpers';

function getAll() {
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  };

  return fetch(`/api/Lookups?PageSize=100&OrderBy=description&OrderByAsc=true`, requestOptions as any)
    .then(handleResponse)
    .then(response => {
      return response.data;
    });
}

function getById(id: any) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  };

  return fetch(`/api/Lookups/${id}`, requestOptions as any)
    .then(handleResponse)
    .then(response => {
      localStorage.setItem('lookup', JSON.stringify(response.data));

      return response.data;
    });
}

function updateLookupItem(lookupId: number, id: number, model: any) {
  const requestOptions = {
    method: 'PUT',
    headers: authHeader(),
    body: JSON.stringify(model)
  };

  return fetch(`/api/Lookups/${lookupId}/items/${id}`, requestOptions as any).then(handleResponse);
}

function createLookupItem(id: number, model: any) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader(),
    body: JSON.stringify(model)
  };

  return fetch(`/api/Lookups/${id}/items`, requestOptions as any).then(handleResponse);
}

function updateLookup(id: number, model: any) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader(),
    body: JSON.stringify(model)
  };

  return fetch(`/api/Lookups/${id}`, requestOptions as any).then(handleResponse);
}

export const lookupService = {
  getAll,
  getById,
  updateLookupItem,
  createLookupItem,
  updateLookup
};
